module.exports = __webpack_public_path__ + "static/media/card-design-happy-birthday.ba43ab70.png";